import FormError from 'components/Forms/FormError/FormError';
import SelectInput from 'components/shared/SelectInput';
import {
  AMBIENT_AWARENESS_QUERIES_EXAMPLES,
  PERCEPTION_MODELS
} from 'entities/tavus';
import { ITavusPersonaFormik } from 'entities/tavus/persona';
import { FieldArray, FormikProps, FormikProvider, getIn } from 'formik';
import { FC } from 'react';
import { cn } from 'shared/lib';

interface IProps {
  formik: FormikProps<ITavusPersonaFormik>;
}
export const Perception: FC<IProps> = ({ formik }) => {
  return (
    <div>
      <div className="ag-flex ag-flex-col ag-relative">
        <label className="ag-mb-1.5  ag-text-base">
          <div className="ag-text-neutral-900 ag-font-semibold">
            Perception Model
          </div>

          <div className="ag-text-gray-muted">
            Selects the perception model to use
          </div>
        </label>

        <SelectInput
          name="select-model-perception"
          options={PERCEPTION_MODELS.map((item) => item.name)}
          value={
            PERCEPTION_MODELS.find(
              (item) =>
                item.value.toLowerCase() === formik.values.perceptionModel
            )!?.name
          }
          onChange={(value) =>
            formik.setFieldValue(
              'perceptionModel',
              PERCEPTION_MODELS.find((item) => item.name === value)?.value
            )
          }
          optionsWrapperClassName={cn(
            '!ag-bg-white !ag-border-neutral-200 ag-max-h-60'
          )}
          className={cn(
            '!ag-bg-white !ag-border-neutral-200 !ag-text-neutral-700 !ag-px-3 !ag-py-2 ag-mb-6'
          )}
          wrapperClassName={cn(
            '!ag-bg-white !ag-text-neutral-700 !ag-border-neutral-200'
          )}
          optionsClassName={cn(
            'ag-text-sm ag-py-1 ag-text-neutral-700 ag-border-neutral-200  hover:ag-bg-neutral-200/80 dark:hover:ag-bg-[#262626]/80'
          )}
          activeClassName={cn('!ag-bg-neutral-100')}
        />
      </div>
      {formik.values.perceptionModel === 'lucia-0.1' && (
        <>
          <div className="ag-flex ag-flex-col ag-relative ag-mb-4">
            <label className="ag-mb-1.5 ag-text-base">
              <div className="ag-text-neutral-900 ag-font-semibold">
                Visual Awareness prompt
              </div>
              <div className="ag-text-gray-muted">
                Every day our human eyes see millions of images, but we only
                notice some things when prompted. Help your avatar to notice
                things they might not have noticed with this prompt
              </div>
            </label>
            <FormikProvider value={formik}>
              <FieldArray
                name="ambientAwarenessQueries"
                render={(arrayHelpers) => (
                  <div>
                    {formik.values.ambientAwarenessQueries.map(
                      (query, index) => (
                        <div
                          key={index}
                          className="ag-flex ag-items-start ag-mb-2"
                        >
                          <textarea
                            placeholder={`For example, "${
                              AMBIENT_AWARENESS_QUERIES_EXAMPLES[index % 12]
                            }"`}
                            className={cn(
                              'ag-border ag-w-full ag-border-neutral-300 ag-py-2 ag-px-3 ag-rounded-md ag-outline-none ag-ring-0 focus:ag-outline-none focus:ag-ring-0',
                              getIn(
                                formik.errors,
                                `ambientAwarenessQueries[${index}]`
                              ) &&
                                getIn(
                                  formik.touched,
                                  `ambientAwarenessQueries[${index}]`
                                )
                                ? 'ag-text-red-900  focus:ag-border-red-500'
                                : 'placeholder:ag-text-gray-400 focus:ag-border-primary-800'
                            )}
                            name="customGreeting"
                            id="customGreeting"
                            rows={2}
                            onBlur={formik.handleBlur}
                            onChange={formik.handleChange}
                            value={formik.values.customGreeting}
                          />
                          {formik.errors.customGreeting &&
                            formik.touched.customGreeting && (
                              <FormError>
                                {formik.errors.customGreeting}
                              </FormError>
                            )}
                          <button
                            type="button"
                            className="ag-ml-2 ag-text-red-500 hover:ag-text-red-700 ag-font-semibold"
                            onClick={() => arrayHelpers.remove(index)}
                          >
                            Remove
                          </button>
                        </div>
                      )
                    )}
                    <button
                      type="button"
                      className="ag-mt-2 ag-text-primary-600 hover:ag-text-primary-700 ag-font-semibold"
                      onClick={() => arrayHelpers.push('')}
                    >
                      Add Query
                    </button>
                    {formik.errors.ambientAwarenessQueries &&
                      typeof formik.errors.ambientAwarenessQueries ===
                        'string' && (
                        <FormError>
                          {formik.errors.ambientAwarenessQueries}
                        </FormError>
                      )}
                  </div>
                )}
              />
            </FormikProvider>
          </div>
        </>
      )}
    </div>
  );
};
